import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import store from './store'
import Vuesax from 'vuesax'
import VueScrollReveal from 'vue-scroll-reveal';
import "./assets/css/estilos.css";
import "./assets/css/persiana.css";
import "./assets/css/estilo_contenido.css";
import "./assets/css/componentes.css";
import "./assets/css/sala-de-prensa.css";
import "./assets/css/select2.css";
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'vuesax/dist/vuesax.css'
import "./assets/css/select.css"
// require('./assets/css/estilos.css')

Vue.use(Vuesax, {
  // options here
})

Vue.use(VueScrollReveal, {
  class: 'v-scroll-reveal',
  duration: 1800,
  scale: 1,
  distance: '100px',
  mobile: true
});
Vue.config.productionTip = true


//## DOMINIO, SERVER DONDE ESTA ALOJADO ##\\
let dominio = 'https://evolucion.finanzaschiapas.gob.mx:8083/';

Vue.prototype.$urlServidor = dominio;

//Vue.prototype.urlServe = dominio+'HaciendaChiapas/'                    // <--- repositorio de archivos
Vue.prototype.urlServearchivos2 = 'http://www.haciendachiapas.gob.mx/SitioNuevo/info/'
Vue.prototype.urlServearchivos = 'http://www.finanzaschiapas.gob.mx/SitioNuevo/info/'

Vue.prototype.urlServeavisos = 'http://www.finanzaschiapas.gob.mx/SitioNuevo/info/aviso-privacidad/'

Vue.prototype.urlServe2 = 'https://www.haciendachiapas.gob.mx/'
Vue.prototype.urlServe = 'https://www.finanzaschiapas.gob.mx/'
Vue.prototype.urlServePresupuesto = 'https://presupuesto.finanzaschiapas.gob.mx/'

Vue.prototype.$urlServiciosRetys = 'http://api.retys.chiapas.gob.mx/'

Vue.prototype.$urlServiciosHacienda = dominio+'ServiciosHacendarios/'  // <--- servicio municipios y periodico

Vue.prototype.$urlTramitesHacienda = 'http://200.57.183.210/SIFOSH/api/formato/' // <--- api ing adriano
Vue.prototype.urlSitioNuevo = 'https://www.finanzaschiapas.gob.mx/SitioNuevo/' // <-- sitio nuevo de hacienda

Vue.component('px-select', require('../src/views/PxSelect.vue').default);

/* URL PARA SUBDOMINIOS DONDE ANTECEDE ALGUNA DEPENDENCIA
EJEMPLO: http://www.transparencia.haciendachiapas.gob.mx/    */
Vue.prototype.urlSubdominio2 = 'haciendachiapas.gob.mx' //<-----este lo uso en el apartado de planeacion (loginRegistro.vue)
Vue.prototype.urlSubdominio  = 'finanzaschiapas.gob.mx/'
Vue.prototype.urlSubdominioServices  = 'finanzaschiapas.gob.mx'
Vue.prototype.namePagina = 'finanzaschiapas' // <- este se cambiara a finanzas


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
